export const ASCENDENT = "ASCENDENT";
export const DESCENDENT = "DESCENDENT";
export const NONE = "NONE";
